import React, { useEffect, useRef } from "react";
function Statistic() {
    const ProgressBar = ({ title, percent }) => {
        const progressBarRef = useRef(null);

        useEffect(() => {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const progressBars = entry.target.querySelectorAll(".progress-bar");
                        progressBars.forEach((bar) => {
                            const percent = bar.getAttribute("data-percent");
                            bar.style.width = `${percent}%`;
                        });
                    }
                });
            });

            observer.observe(progressBarRef.current);

            return () => {
                observer.disconnect();
            };
        }, []);

        return (
            <div className="mb-4" ref={progressBarRef}>
                <div className="progress-header">
                    <h6 className="progress-title">{title}</h6>
                </div>
                <div className="progress-area mb-3">
                    <div className="progress-bar" data-percent={percent}></div>
                </div>
            </div>
        );
    };
    return (
        <div id="block-one" className="section pt-6 pt-md-7 pb-5 pb-md-6 bg-light-dark">
            <div className="container">
                <div className="tab-content" id="tabs-content1">
                    <div className="tab-pane fade show active" id="onecontent-1" role="tabpanel" aria-labelledby="onenav-1">
                        <div className="row">
                            <div className="col-lg-6" data-aos="flip-up">
                                <div className="me-2 p-4">
                                    <p >In the IT sector, we are constantly enhancing our capabilities to ensure seamless delivery at any scale.
                                    </p>                                    
                                    <p >
                                        Let the thrill of achievement propel you forward. Take a moment to envision your personal definition of success, encapsulated in an image that resonates with your aspirations. Keep this visual reminder close at hand, ready to reignite your motivation during pivotal moments.</p>
                                    <p>
                                        Embrace the collective energy of the tech community, where determination and ingenuity converge to forge new frontiers of possibility. Together, we celebrate milestones and overcome challenges, driving progress and shaping the future of technology.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-5 offset-xl-1">
                                <div className="progress-line-trigger">
                                    <ProgressBar title="ASP.Net" percent={90} />
                                    <ProgressBar title=".Net Core" percent={75} />
                                    <ProgressBar title="Jquery" percent={89} />
                                    <ProgressBar title="React" percent={80} />
                                    <ProgressBar title="React-Native" percent={73} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Statistic;